import {
	Shield,
	Wallet,
	BarChart3,
	Plug,
	Zap,
	Lock,
} from 'lucide-react';
import styles from './Features.module.css';

const features = [
	{
		icon: Shield,
		title: 'Provably Fair',
		description:
			'HMAC-SHA256 based random number generation with cryptographic verification. Every bet can be independently verified by players.',
	},
	{
		icon: Wallet,
		title: 'Seamless Wallet',
		description:
			'Hub88-style wallet callbacks for real-time balance updates. Support for both seamless and transfer wallet modes.',
	},
	{
		icon: BarChart3,
		title: 'Real-time Analytics',
		description:
			'Comprehensive dashboards with live metrics. Track player activity, game performance, and revenue in real-time.',
	},
	{
		icon: Plug,
		title: 'Easy Integration',
		description:
			'RESTful API with comprehensive documentation. Launch your first game in under an hour with our SDK.',
	},
	{
		icon: Zap,
		title: 'Instant Settlement',
		description:
			'Sub-50ms latency for all game operations. Instant payouts and balance updates powered by edge computing.',
	},
	{
		icon: Lock,
		title: 'Enterprise Security',
		description:
			'End-to-end encryption, API key authentication, and comprehensive audit logging. SOC 2 compliant infrastructure.',
	},
];

export default function Features() {
	return (
		<section className={styles.features} id="features">
			<div className={styles.container}>
				<div className={styles.header}>
					<span className={styles.badge}>Features</span>
					<h2 className={styles.title}>
						Everything You Need to Run a Crypto Casino
					</h2>
					<p className={styles.subtitle}>
						Our platform handles the complexity of provably fair gaming, wallet
						integration, and compliance so you can focus on growing your business.
					</p>
				</div>

				<div className={styles.grid}>
					{features.map((feature) => {
						const Icon = feature.icon;
						return (
							<div key={feature.title} className={styles.card}>
								<div className={styles.iconWrapper}>
									<Icon size={24} className={styles.icon} />
								</div>
								<h3 className={styles.cardTitle}>{feature.title}</h3>
								<p className={styles.cardDescription}>{feature.description}</p>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}
